import React from 'react';
import { StepType, TourProvider, components } from '@reactour/tour';
import history from 'src/libs/history';
import { Button } from 'semantic-ui-react';

import { PATH } from 'src/constants/app';
import { useAppDispatch } from 'src/store';
import { firstLogin } from 'src/thunks/auth';

const InstructionTour: React.FC = ({ children }) => {
  const steps: StepType[] = [
    {
      selector: 'body',
      content: (
        <div className="mb-36">
          <h4 className="mb-8">Welcome to IVA!</h4>
          <p className="fs-16">
            Hi there! 👋 Welcome to the IVA Community. We are excited for you to
            kickstart your journey in Venture Capital. Let us give you a quick
            tour.
          </p>
        </div>
      ),
    },
    {
      selector: 'li[id="home"]',
      content: (
        <div className="mb-36">
          <h4 className="mb-8">View available Courses</h4>
          <p className="fs-16">Discover new and current courses here.</p>
        </div>
      ),
      action: () => history.push('/'),
    },
    // {
    //   selector: `div[id=${PATH.DIRECTORY}]`,
    //   content: (
    //     <div className="mb-36">
    //       <h4 className="mb-8">Discover VC Members</h4>
    //       <p className="fs-16">
    //         Connect with members of the Insignia community.
    //       </p>
    //     </div>
    //   ),
    //   action: () => history.push(`/${PATH.DIRECTORY}`),
    // },
    {
      selector: `li[id=${PATH.FAQS}]`,
      content: (
        <div className="mb-36">
          <h5>Have questions on our courses? </h5>
          <p className="fs-16">Get answers here.</p>
        </div>
      ),
      action: () => history.push(`/${PATH.FAQS}`),
    },
    {
      selector: `img[id="user_dropdown"]`,
      content: (
        <div className="mb-36">
          <h4 className="mb-8">Manage your profile</h4>
          <p className="fs-16">
            Edit your profile, account and subscription settings and more.
          </p>
        </div>
      ),
      action: () => history.push(`/${PATH.SETTING}`),
    },
    {
      selector: `.app_header_search`,
      content: (
        <div className="mb-36">
          <h5>Use the search bar to look specific items.</h5>
        </div>
      ),
    },
  ];

  return (
    <TourProvider
      components={{
        Badge: () => <React.Fragment />,
        Navigation: PopoverNavigation,
        Close: () => <React.Fragment />,
      }}
      steps={steps}
      styles={{
        popover: (props, state) => {
          return { ...state, ...props, borderRadius: 4 };
        },
        maskArea: (props, state) => {
          if (
            window.innerWidth <= props.width &&
            window.innerHeight <= props.height
          ) {
            return { ...state, ...props, width: 0, height: 0 };
          }
          return { ...state, ...props };
        },
      }}
    >
      {children}
    </TourProvider>
  );
};

export type PopoverNavigationProps =
  typeof components['Navigation'] extends React.FC<infer R> ? R : never;

export const PopoverNavigation: React.FC<PopoverNavigationProps> = (props) => {
  const { setCurrentStep, currentStep, steps } = props;
  const isLast = currentStep === steps.length - 1;
  const dispatch = useAppDispatch();

  return (
    <div className="d-flex justify-end align-center">
      {!isLast && (
        <a
          className="px-24 cursor-pointer"
          onClick={() => {
            setCurrentStep(steps.length);
            dispatch(firstLogin({}));
          }}
        >
          {'Skip'}
        </a>
      )}
      <Button
        size="small"
        primary
        onClick={() => {
          setCurrentStep((s) => s + 1);
          isLast && dispatch(firstLogin({}));
        }}
      >
        {isLast ? 'Done' : 'Next'}
      </Button>
    </div>
  );
};

export default InstructionTour;
